const STORAGE_KEY = "onetak_guest_token";

/**
 * 비회원 장바구니/주문 식별용 토큰. 최초 접속 시 1회 생성해 로컬저장소에 보관하고,
 * 이후 모든 요청에 "X-Guest-Token" 헤더로 실어 보낸다 (백엔드 TB_CART.guest_token 과 매칭).
 * 회원 로그인 후에도 그대로 두되, 서버는 Authorization 헤더가 있으면 이 값을 무시한다.
 */
export function getGuestToken() {
  let token = window.localStorage.getItem(STORAGE_KEY);
  if (!token) {
    token = generateUuid();
    window.localStorage.setItem(STORAGE_KEY, token);
  }
  return token;
}

function generateUuid() {
  if (window.crypto && typeof window.crypto.randomUUID === "function") {
    return window.crypto.randomUUID();
  }
  // 구형 브라우저 대비 폴백
  return "guest-" + Date.now() + "-" + Math.random().toString(16).slice(2);
}
